/** Coalesce browser-local saves. Serialization and synchronous storage happen
 * only while movement/traversal is quiet, or on an explicit lifecycle flush. */
export function createDeferredPersistence({serialize,write,isBusy=()=>false,onResult=()=>{},
  schedule=(run,delay)=>setTimeout(run,delay),cancel=id=>clearTimeout(id),
  idle=run=>typeof requestIdleCallback==='function'?requestIdleCallback(run):setTimeout(run,0),
  cancelIdle=id=>typeof cancelIdleCallback==='function'?cancelIdleCallback(id):clearTimeout(id),
  now=()=>performance.now()}={}) {
  let dirty=false,timer=null,idleId=null,disposed=false;
  const stats={writes:0,lastWriteMilliseconds:0,pending:false};
  function queue(delay=150) {
    if(disposed||timer!==null||idleId!==null||!dirty)return;
    timer=schedule(()=>{timer=null;idleId=idle(()=>{idleId=null;flush();});},delay);
  }
  function flush({force=false}={}) {
    if(disposed||!dirty)return false;
    if(!force&&isBusy()){queue(250);return false;}
    if(timer!==null){cancel(timer);timer=null;}
    if(idleId!==null){cancelIdle(idleId);idleId=null;}
    dirty=false;stats.pending=false;const start=now();
    try {write(serialize());stats.writes++;onResult(null);}
    catch(error) {onResult(error);}
    stats.lastWriteMilliseconds=now()-start;return true;
  }
  return {
    request(){if(disposed)return;dirty=true;stats.pending=true;queue();},flush,
    getStats:()=>({...stats}),
    dispose(){disposed=true;if(timer!==null)cancel(timer);if(idleId!==null)cancelIdle(idleId);dirty=false;stats.pending=false;},
  };
}
